import { render } from "./announcements.vue?vue&type=template&id=151c8886&scoped=true"
import script from "./announcements.vue?vue&type=script&lang=js"
export * from "./announcements.vue?vue&type=script&lang=js"

import "./announcements.vue?vue&type=style&index=0&id=151c8886&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151c8886"]])

export default __exports__